<template>
  <el-row :gutter="0" v-loading="loading" >
    <el-col style="height: calc(100vh - 95px);">
      <!-- 页面主体 -->
      <el-row class="main_content_header" ref="tabs">
        <!-- 课程类别 -->
        <el-tabs
          v-if="allCategorys.length !== 0"
          v-model="activeCategory"
          style="width: 100%"
          @tab-change="handleCategoryChange"
        >
          <el-tab-pane
            v-for="category in allCategorys"
            :key="category.category_id"
            :label="category.category_name"
            :name="category.category_id"
          >
            <!-- 课程分类过滤器 -->
            <el-row :gutter="0">
              <el-col v-if="!isMobile" :xl="2" :lg="2" :md="3"><span style="line-height: 32px; padding-left: 20px">课程分类:</span></el-col>
              <el-col :xl="18" :lg="18" :md="16">
                <el-button :type="activeItem === '' ? 'primary' : ''" text @click="handleFilterItemClick('all')">
                  {{ `全部 (${currentCategoryCourseCount})` }}
                </el-button>
                <el-button
                  v-for="item in currentCategoryItems"
                  :key="item.item_id"
                  :type="activeItem === item.item_id ? 'primary' : ''"
                  @click="handleFilterItemClick(item)"
                  :text="true"
                >
                  {{ `${item.item_name} (${allCourses[item.item_id].length})` }}
                </el-button>
              </el-col>
              <el-col :xl="4" :lg="4" :md="5">
                <el-input v-model="searchCourse" placeholder="请输入课程名称" @input="handleCourseSearch" />
              </el-col>
            </el-row>
            <!-- <el-divider /> -->
          </el-tab-pane>
        </el-tabs>
      </el-row>
      <el-row ref="mainContents">
        <el-scrollbar :height="scrollMaxHeight" style="width: 100%">
          <el-row class="main_content_card">
            <el-row v-if="allCategorys.length !== 0" style="width: 100%">
              <!-- 课程卡片 -->
              <el-empty v-if="currentCourses.length === 0" description="暂无数据" style="margin: 0 auto" />
              <el-row v-else :gutter="0" style="width: 100%">
                <el-col :span="24">
                  <el-container class="course_list">
                    <div
                      v-for="course in currentCourses"
                      :key="course.course_id"
                      class="course_card"
                      :style="styleCouseCardVar"
                    >
                      <el-row :gutter="0" style="cursor: pointer; overflow: hidden;" @click="handleCourseJump(course.course_id)">
                        <el-image v-if="course.image" :src="course.image" class="course_image" fit="fill" :style="styleCouseCardVar">
                          <template #error>
                            <el-row :gutter="0" class="default_course_img" :style="styleCouseCardVar"/>
                          </template>
                        </el-image>
                        <el-row v-else :gutter="0" class="default_course_img" :style="styleCouseCardVar"/>
                      </el-row>
                      <el-row :gutter="0">
                        <el-col :span="24" style="height: 40px">
                          <el-link
                            :href="course.course_link || `/courses/${course.course_id}`"
                            target="_blank"
                            :underline="false"
                            class="course_name_link"
                          >
                            <span class="course_name" :title="course.course_name" :style="styleCouseCardVar">
                              {{ course.course_name }}
                            </span>
                          </el-link>
                        </el-col>
                        <el-col :span="24">
                          <el-tag class="difficulty_degree" :style="styleCouseCardVar">
                            {{ course.difficulty_degree ? courseDifficulty[course.difficulty_degree] : courseDifficulty[3] }}
                          </el-tag>
                          <el-tag class="study_time" :style="styleCouseCardVar">
                            {{ course.lessons ? course.lessons : '未设置' }}
                          </el-tag>
                          <span
                            class="course_student_count"
                          >{{ course.student_count }} 参与</span>
                        </el-col>
                        <el-col :span="24">
                          <!-- <el-popover
                            placement="auto"
                            title="简介"
                            :width="600"
                            :show-after="600"
                            trigger="hover"
                            :disabled="isMobile"
                          >
                            <template #reference>
                              <p class="course_short_description">{{ course.description }}</p>
                            </template>
                            <el-scrollbar :max-height="400">
                              <div style="padding: 20px" v-html="course.rich_content || course.description"></div>
                            </el-scrollbar>
                          </el-popover> -->
                          <p class="course_short_description" :title="course.description">{{ course.description }}</p>
                        </el-col>
                      </el-row>
                    </div>
                  </el-container>
                </el-col>
              </el-row>
            </el-row>
            <el-empty v-else description="暂无数据" style="margin: 0 auto" />
          </el-row>
          <div v-loading="loadMore" />
        </el-scrollbar>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import axios from 'axios'
import { throttle } from '../utils'
import fakeStudentCount from '/src/fake_student_count.js'
// import studyTime from '/src/course_time.js'

export default {
  name: 'Home',
  data() {
    return {
      courseDifficulty: {
        '1': '入门',
        '2': '初级',
        '3': '中级',
        '4': '高级',
        '5': '进阶',
      },
      activeCategory: '',
      activeItem: '',
      allCategorys: [],
      allCategoryItems: {},
      allCourses: {},
      currentCategoryCourseCount: 0,
      currentCategoryItems: [],
      currentCourses: [],  // 保存当前条件下的课程对象，用作页面展示集
      searchCourse: '',  // 课程搜索关键字
      searchCourseList: [],  // 保存当前分类下的所有课程，用来当作搜索集
      scrollMaxHeight: window.innerHeight - 95 - 126,
      loading: false,
      loadMore: false, // 页面懒加载的loading控制
      hasMore: true,
      fakeCourseData: true,
      isMobile: document.documentElement.clientWidth <= 1000, //判断是不是手机端
      
    }
  },
  watch: {
    // watch 加 $nextTick 可以实现实时监控tabs部分渲染完毕后的事件，触发高度计算，实现内容区高度自适应
    allCategoryItems: function() {
      this.$nextTick(() => {
        // 95: 包含页面头部60，页面尾部20，以及尾部上下间距 10 + 5
        // tabs: 组件只有一行分类的时候高度是 126
        this.scrollMaxHeight = window.innerHeight - 95 - this.$refs.tabs.$el.offsetHeight
      })
    }
  },
  mounted() {
    this.getData()
    this.lazyLoad()
  },
  methods: {
    updateCourseData(start, end, newCourses) {
      this.currentCourses = []
      if (newCourses) {  // 返回搜索结果
        this.currentCourses.push(...newCourses)
        this.hasMore = false
        return
      }
      this.searchCourseList = []
      this.hasMore = true
      if (this.activeItem !== '') {
        this.currentCourses.push(...this.allCourses[this.activeItem].slice(start || 0, end || 15))
        this.searchCourseList.push(...this.allCourses[this.activeItem])
      } else {
        this.currentCourses.push(...this.allCourses[this.activeCategory].slice(start || 0, end || 15))
        this.searchCourseList.push(...this.allCourses[this.activeCategory])
        this.currentCategoryCourseCount = this.allCourses[this.activeCategory].length
      }
    },
    backToTop() {
      this.$refs.mainContents.$el.querySelector('.el-scrollbar__wrap').scrollTop = 0
    },
    handleCategoryChange(categoryId) {
      this.backToTop()
      this.activeCategory = categoryId
      this.activeItem = ''
      this.currentCategoryItems = this.allCategoryItems[categoryId]
      this.updateCourseData()
    },
    handleFilterItemClick(item) {
      this.backToTop()
      this.activeItem = item === 'all' ? '' : item.item_id
      this.updateCourseData()
    },
    handleCourseJump(courseId) {
      window.open(`/courses/${courseId}`)
    },
    handleCourseSearch() {
      this.backToTop()
      if (this.searchCourse === '') {
        this.updateCourseData()
        return
      }
      const tmpCourseList = []
      this.searchCourseList.map(c => {
        if (c.course_name.indexOf(this.searchCourse) >= 0) {
          tmpCourseList.push(c)
        }
      })
      this.updateCourseData(0, 15, tmpCourseList)
    },
    getData() {
      this.loading = true
      const url = '/courses_category/'
      axios.get(url).then(res => {
        if (res.data) {
          this.allCategorys = res.data.allCategorys
          this.allCategoryItems = res.data.allCategoryItems
          this.allCourses = res.data.allCourses
          // this.allCourses = this.getAllCourse(res.data.allCourses)
          this.activeCategory = res.data.allCategorys[0].category_id
          this.currentCategoryItems = this.allCategoryItems[this.activeCategory]
          if (this.fakeCourseData) {
            this.randomStudentCount()
          }
          this.updateCourseData()
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.$message({ type: 'error', message: '数据加载失败！' })
        this.loading = false
      })
    },
    lazyLoad() {
      const dom = this.$refs.mainContents.$el.querySelector('.el-scrollbar__wrap')
      dom.addEventListener('scroll', throttle(() => {
        let step = 10
        const isBottom = dom.scrollHeight - dom.scrollTop - dom.clientHeight < 1
        if (this.currentCourses.length >= this.searchCourseList.length) {
          this.hasMore = false
          return
        }
        if (isBottom && this.hasMore) {
          this.loadMore = true
          setTimeout(() => {
            this.currentCourses.push(...this.searchCourseList.slice(this.currentCourses.length, this.currentCourses.length + step))
            this.loadMore = false
          }, 500)
        }
      }, 200))
    },
    /**
     * 工具类
     */
    randomStudentCount() {
      let index = 0
      const uniqueCourseMap = {}
      for (let itemId in this.allCourses) {
        this.allCourses[itemId].forEach(course => {
          if (uniqueCourseMap[course.course_id]) {
            course.student_count = uniqueCourseMap[course.course_id]
          } else {
            course.student_count = fakeStudentCount[index]
            uniqueCourseMap[course.course_id] = fakeStudentCount[index]
            index++
          }
        })
      }
    },
    removeImageFromCourseWikiPage(courses_info) {
      const imgReg = /<img?.*?>/
      const beginReg = /<table?.*?>/
      const endReg = /<\/table>/
      for (let itemId in courses_info) {
        courses_info[itemId].forEach(course => {
          if (course.rich_content && beginReg.test(course.rich_content) && imgReg.test(course.rich_content)) {
            course.rich_content = course.rich_content.replace(beginReg, 'tableStartIndex')
            course.rich_content = course.rich_content.replace(endReg, 'tableEndIndex')
            const startIdx = course.rich_content.indexOf('tableStartIndex')
            const endIdx = course.rich_content.indexOf('tableEndIndex')
            const tableContent = course.rich_content.substring(startIdx, endIdx + 13)
            course.rich_content = course.rich_content.replace(tableContent, '')
          }
          // course.rich_content = course.rich_content ? course.rich_content.replace(/<img?.*?>/g, '') : null
        })
      }
      return courses_info
    },
    // getAllCourse(courses_info) {
    //   for (let itemId in courses_info) {
    //     courses_info[itemId].forEach(course => {
    //       course['study_time'] = studyTime[course.course_name.trim()]
    //     })
    //   }
    //   return courses_info
    // }
  },
  computed: {
    styleCouseCardVar() {
      return {
        '--course-card-height': this.isMobile ? '260px' : '300px',
        '--course-card-width': this.isMobile ? '170px' : '240px',
        '--course-img-height': this.isMobile ? '120px' : '160px',
        '--course-name-max-width': this.isMobile ? '160px' : '230px',
        '--difficulty-degree-margin-left': this.isMobile ? '2px' : '10px',
        '--study-time-margin-left': this.isMobile ? '2px' : '20px',
      }
    }
  }
}
</script>

<style>
.main_content_header {
  max-width: 1350px;
  margin: 0 auto;
  padding: 20px;
}
.main_content_card {
  max-width: 1350px;
  margin: 0 auto;
}
.course_list {
  overflow: auto;
  flex-wrap: wrap;
  max-width: 1310px;
  margin: 0 auto;
}
.course_card {
  height: var(--course-card-height);
  width: var(--course-card-width);
  margin: 10px 10px 30px 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}
.course_card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 15px 0 rgba(0, 0, 0, 0.19);
}
.course_image {
  height: var(--course-img-height);
  width: 100%;
  transition: all 0.5s;
}
.course_image:hover {
  transform: scale(1.1);
}
.default_course_img {
  height: var(--course-img-height);
  width: 100%;
  background-color: #f4f4f4;
}
.course_name_link {
  margin-left: 10px;
  line-height: 40px;
}
.course_name {
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: var(--course-name-max-width);
  overflow: hidden;
}
.course_student_count {
  font-size: 12px;
  color: #aeaeae;
  position: absolute;
  right: 15px;
}
.course_short_description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  font-size: 12px;
  /* text-indent: 2em; */
  margin: 10px;
  height: 56px;
  line-height: 1.5;
  word-break: break-word;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.difficulty_degree {
  margin-left: var(--difficulty-degree-margin-left);
}
.study_time {
  margin-left: var(--study-time-margin-left);
}
</style>